import type { RootState } from '..';

export const state = (state: RootState) => state.monitoringSystemUser.state;

export const action = (state: RootState) => state.monitoringSystemUser.action;

export const error = (state: RootState) => state.monitoringSystemUser.error;

export const list = (state: RootState) => state.monitoringSystemUser.list;

export const monitoringSystemUser = (state: RootState) =>
  state.monitoringSystemUser.monitoringSystemUser;
